<ncp-table #treatments [(options)]="options"></ncp-table>
